import { ELEMENT_EVENT } from "../types/constants";
import { SELECTOR } from "../types/element/constants";
import { SquirrelEvents } from "../types/sqrl";
import { SQRL_EVENT } from "../types/sqrl/constants";

let searchForm: HTMLFormElement | null = null;

function reset() {
  searchForm = null;
}

function init() {
  const parentWrapper: HTMLDivElement = document.querySelector(SELECTOR.SEARCH_CONTAINER) as HTMLDivElement;

  if (!searchForm && parentWrapper) {
    searchForm = parentWrapper.querySelector(SELECTOR.SEARCH_FORM) as HTMLFormElement;
    const suggestLayer: HTMLDivElement = parentWrapper.querySelector(SELECTOR.LAYER) as HTMLDivElement;
    const searchField: HTMLInputElement = parentWrapper.querySelector(SELECTOR.SEARCH_FIELD) as HTMLInputElement;

    /*                        */
    if (suggestLayer) {
      window.o_util.event.delegate(
        SELECTOR.LAYER,
        ELEMENT_EVENT.CLICK,
        SELECTOR.SUGGEST_TERM,
        window.o_squirrel.searchSuggest.onSuggestItemClick,
      );
      window.o_util.event.delegate(
        SELECTOR.LAYER,
        ELEMENT_EVENT.CLICK,
        SELECTOR.MODIFIED_ARROW,
        window.o_squirrel.searchSuggest.clickArrowAction,
      );
      window.o_util.event.delegate(
        SELECTOR.LAYER,
        ELEMENT_EVENT.CLICK,
        SELECTOR.HISTORY_EDIT_BUTTON,
        window.o_squirrel.searchHistory.clickEditAction,
      );
      window.o_util.event.delegate(
        SELECTOR.LAYER,
        ELEMENT_EVENT.CLICK,
        SELECTOR.HISTORY_CLASS,
        window.o_squirrel.searchHistory.clickTermAction,
      );
      window.o_util.event.delegate(
        SELECTOR.LAYER,
        ELEMENT_EVENT.CLICK,
        SELECTOR.HISTORY_DELETEALL,
        window.o_squirrel.searchHistory.clickDeleteAllAction,
      );

      window.o_squirrel.searchSuggest.init();
      window.o_squirrel.searchHistory.init();
      window.o_squirrel.emptyStateSuggest.init();

      searchField.addEventListener(ELEMENT_EVENT.INPUT, window.o_squirrel.searchSuggest.handleInput);
      searchField.onkeydown = window.o_squirrel.searchSuggest.handleKeyAction;
      /*                                                                                                        */
      searchField.addEventListener(ELEMENT_EVENT.FOCUS, window.o_squirrel.searchSuggest.focusSearchFieldAction);
      searchField.addEventListener(ELEMENT_EVENT.FOCUS_OUT, window.o_squirrel.searchSuggest.focusOutSearchFieldAction);
      window.addEventListener(ELEMENT_EVENT.BLUR, window.o_squirrel.searchSuggest.blurWindowAction);
      /*                      */
      searchField.addEventListener("dblclick", () => {
        const christmasDate: Date = window.o_squirrel.christmasDate;
        const today: Date = new Date();
        const diffTime = christmasDate.getTime() - today.getTime();
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        if (searchField.classList.contains("squirrel_christmas")) {
          searchField.classList.remove("squirrel_christmas");
        } else if (diffDays >= 0) {
          searchField.classList.add("squirrel_christmas");
        }
      });
      window.o_global
        .events<SquirrelEvents>()
        .on(SQRL_EVENT.SEARCH_FOCUS, window.o_squirrel.navSlider.onMergeEventContext);

      /*                                                                                                          */
      /*                                                                     */
      /*                                                                        */
      window.o_squirrel.searchSuggest.fetchSuggestions(searchField.value || "", 0, {
        headers: {
          "x-request-type": "init",
        },
      });
    }
  }
}

export const suggestLayer = {
  init,
  reset,
};
